import { render, staticRenderFns } from "./AddStockDialog.vue?vue&type=template&id=7b89d2bd"
import script from "./AddStockDialog.vue?vue&type=script&lang=js"
export * from "./AddStockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports